import {type Type, Plugins} from '@packages/systems/wfdl';
import {emptyObject} from '@packages/utilities/fp/utils';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';

export const migrateUnionDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Union') {
    const newDataType: Type = {
      type: 'TypeApplication',
      val: {
        con: {
          type: 'TypeConstructor',
          val: qualify(Plugins.name('Builtin'), typeName('Union')),
        },
        arg: Object.entries(dataTypeJson.values || emptyObject).reduce(
          (row, [key, value]: [any, any]) => {
            const {label, type} = value;
            const newRow: any = {
              type: 'RowCons',
              val: {
                label: key,
                type,
                tail: row,
              },
            };
            if (label) {
              newRow.system = {label};
            }
            return newRow;
          },
          {type: 'RowEmpty'}
        ),
      },
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
